import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var SvgAvatarUserSQuestion = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("circle", {
        cx: 12,
        cy: 12,
        r: 12,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000
      }), /*#__PURE__*/jsxs("g", {
        fill: props.iconColor ? props.iconColor : "#010505",
        children: [/*#__PURE__*/jsx("circle", {
          cx: 12,
          cy: 12,
          r: 11.75,
          fillOpacity: 0.06,
          stroke: props.iconColor ? props.iconColor : "#010505",
          strokeOpacity: 0.06,
          strokeWidth: 0.5
        }), /*#__PURE__*/jsxs("g", {
          fillOpacity: 0.26,
          transform: "translate(9 6.6)",
          children: [/*#__PURE__*/jsx("path", {
            fillRule: "nonzero",
            d: "M3.07 0c.872 0 1.583.256 2.12.77.539.517.81 1.181.81 1.976q.001.732-.31 1.213c-.192.293-.562.706-1.116 1.248-.37.363-.607.665-.707.894q-.152.342-.153 1.075v.147a.81.81 0 1 1-1.618 0v-.147q-.001-.933.226-1.526c.155-.403.481-.845.976-1.336l.496-.494q.195-.187.313-.387.208-.341.207-.7c0-.345-.1-.637-.3-.887-.184-.228-.506-.349-.986-.349-.591 0-.972.207-1.187.627-.127.245-.204.378-.223.88l-.001.15a.81.81 0 0 1-.813.805A.804.804 0 0 1 0 3.155v-.162C0 2.036.272 1.496.82.901 1.372.3 2.128 0 3.07 0"
          }), /*#__PURE__*/jsx("circle", {
            cx: 2.999,
            cy: 9.9,
            r: 1
          })]
        })]
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var SvgAvatarUserSQuestion$1 = SvgAvatarUserSQuestion;

export { SvgAvatarUserSQuestion$1 as default };
